module.exports = __webpack_public_path__ + "static/media/HCMM719.107ebfa2.jpg";